import { define } from "../preactement/define";
import FilterChip from "../../FilterChip/FilterChip";
import { parseBooleanAttr } from "../wrapperUtils";
import { jsx as _jsx } from "preact/compat/jsx-runtime";
const attributes = ['clear-label', 'class-name', 'label', 'root-id', 'size', 'use-alternate-icon'];

/* eslint-disable @typescript-eslint/no-namespace */

/* eslint-enable */

const Wrapper = _ref => {
  let {
    clearLabel,
    label,
    useAlternateIcon,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/_jsx(FilterChip, {
    ariaClearLabel: clearLabel ?? '',
    label: label,
    useAlternateIcon: parseBooleanAttr(useAlternateIcon),
    ...otherProps
  });
};
define('ds-filter-chip', () => Wrapper, {
  attributes,
  events: [['onDelete', event => ({
    detail: {
      event
    }
  })]]
});